<comp-paged-table
  [dataSource]="dataSource()"
  [editingSupport]="editingSupport()"
  [columns]="['revision', 'intakeType', 'declarationStatus', 'createdAt']"
  [modelObjectProperty]="'model.productRevision'"
>
  <ng-container matColumnDef="revision">
    <!--
      The default sort order for product revisions is "by revision name, descending".
      See com.ul.sis.companion.webapp.api.convert.ComparatorConfiguration
      However, you have to set start="asc" here, because the "start" attribute sets the sort order
      that is applied *after* the first click.
      -->
    <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear start="asc">
      {{ 'model.productRevision.properties.revision' | translate }}
    </th>
    <td mat-cell *matCellDef="let revision">
      <a [routerLink]="[revision.id]" (click)="$event.stopPropagation()" class="revision-name">
        <div class="click-area">
          {{ revision.revision }}
        </div>
      </a>
    </td>
  </ng-container>

  <ng-container matColumnDef="intakeType">
    <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>
      {{ 'model.productRevision.properties.intakeType' | translate }}
    </th>
    <td mat-cell *matCellDef="let revision">
      <comp-intake-type-chip [intakeType]="revision.intakeType"></comp-intake-type-chip>
    </td>
  </ng-container>

  <ng-container matColumnDef="declarationStatus">
    <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>
      {{ 'model.productRevision.properties.declarationStatus' | translate }}
    </th>
    <td mat-cell *matCellDef="let revision">
      <ul-chip
        [additionalClasses]="{
          neutral: revision.declarationStatus === 'PENDING',
          green: revision.declarationStatus === 'VALID',
          red: revision.declarationStatus === 'REVOKED',
        }"
      >
        {{ 'model.productRevision.declarationStatus.' + revision.declarationStatus | translate }}
      </ul-chip>
    </td>
  </ng-container>

  <ng-container matColumnDef="createdAt">
    <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>
      {{ 'model.base.properties.createdAt' | translate }}
    </th>
    <!-- TODO: Use local date format matching browser locale -->
    <td mat-cell *matCellDef="let revision">
      {{ revision.createdAt | date: 'short' }}
    </td>
  </ng-container>
</comp-paged-table>
